import {Channel} from './common';

export class AuthorizeChannel {
  id: number;
}

export class InfluencerChannelAuthorization {
  campaignId: number;
  isAuthenticatedIGChannel: boolean;
  // for contact permission
  permissionToken: string;
  accessToken: string;
  inviteToken: string;
  activeChannelId: number;
  activeChannelIndex: number;
  channelList: Channel[];
}



// WEBPACK FOOTER //
// ./src/models/authorize-channel.ts